import { render, staticRenderFns } from "./HomeLogin.vue?vue&type=template&id=70cfe44c&scoped=true&"
import script from "./HomeLogin.vue?vue&type=script&lang=js&"
export * from "./HomeLogin.vue?vue&type=script&lang=js&"
import style0 from "./HomeLogin.vue?vue&type=style&index=0&id=70cfe44c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfe44c",
  null
  
)

export default component.exports